import { Tabs } from "@mantine/core";
import { GearSixIcon, ListIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classes from "../ui/pill-tabs.module.css";

type Props = {
  active: "list" | "settings";
};

export function ReturnModuleTabs({ active }: Props) {
  const { t } = useTranslation("returns");
  const navigate = useNavigate();

  const onChange = (value: string | null) => {
    if (value === active) return;
    if (value === "list") navigate("/returns");
    else if (value === "settings") navigate("/returns/settings");
  };

  return (
    <Tabs value={active} onChange={onChange} variant="pills" color="dark" radius="md" classNames={{ tab: classes.tabDark }}>
      <Tabs.List>
        <Tabs.Tab value="list" leftSection={<ListIcon size={16} />}>{t("common.list")}</Tabs.Tab>
        <Tabs.Tab value="settings" leftSection={<GearSixIcon size={16} />}>{t("common.settings")}</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
